/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { TSelectOption } from "../../core";
import { FieldWrapper } from "../FieldWrapper";
import { IModeButtonProps, ModeButton } from "../../core/ModeButton";

import "./FieldModeButton.scss";

export interface IFieldModeButtonProps {
	id?: string;
	label?: string;
	value?: string;
	options: TSelectOption[];
	placeholder?: string;
	readOnly?: boolean;
	allowCustomInput?: boolean;
	className?: string;
	onChange?: (value: string) => void;
	preventCompactMode?: IModeButtonProps["preventCompactMode"];
}

export const FieldModeButton: React.FC<IFieldModeButtonProps> = ({
	id: propId,
	value,
	placeholder,
	readOnly,
	options,
	onChange,
	className,
	preventCompactMode
}) => {
	const baseClass = BEM("edt-field-mode-button");

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldWrapper type="mode-button">
			<ModeButton
				className={baseClass.toClassName()}
				options={options}
				onChange={onChange}
				value={value}
				preventCompactMode={preventCompactMode}
			/>
		</FieldWrapper>
	);
};
